export default __webpack_public_path__ + "static/media/close.1eeffb12.png";